// src/pages/Donate/DonateCancel.tsx
import React from 'react';
import { Container, Paper, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const DonateCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          Donation Canceled
        </Typography>
        <Typography variant="body1" gutterBottom>
          Your donation was canceled. If you change your mind, please try donating again.
        </Typography>
        <Box sx={{ mt: 3 }}>
          <Button variant="contained" color="primary" onClick={() => navigate('/donate')}>
            Try Again
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default DonateCancel;
